export default "__VITE_ASSET__BKmbmMK9__"